import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { NOT_STARTED, IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_DIRECT_PLACEMENTS } from '@/lib/constants/api'
import getDirectPlacementModel from './models/directPlacement'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const directPlacement = {
  namespaced: true,
  state: {
    ...getDirectPlacementModel()
  },
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    clearDirectPlacement: (state) => {
      state.id = null
      state.clientId = null
      state.clientName = null
      state.salary = null
      state.paymentReceived = null
      state.placementDate = null
      state.lastPaymentReceivedDate = null
      state.employeeName = null
      state.jobTitle = null
      state.isPaidInFull = null
      state.commissions = []
      state.payments = []
      state.expenses = []
      state.feeTypeId = null
      state.invoiceDate = null
      state.invoiceDueDate = null
      state.fee = null
    },
    setDirectPlacement: (state, directPlacement) => {
      state.id = directPlacement.id
      state.clientId = directPlacement.clientId
      state.clientName = directPlacement.clientName
      state.salary = directPlacement.salary
      state.paymentReceived = directPlacement.paymentReceived
      state.placementDate = directPlacement.placementDate
      state.lastPaymentReceivedDate = directPlacement.lastPaymentReceivedDate
      state.employeeName = directPlacement.employeeName
      state.jobTitle = directPlacement.jobTitle
      state.isPaidInFull = directPlacement.isPaidInFull
      state.commissions = directPlacement.commissions || []
      state.payments = directPlacement.payments || []
      state.expenses = directPlacement.expenses || []
      state.feeTypeId = directPlacement.feeTypeId
      state.invoiceDate = directPlacement.invoiceDate
      state.invoiceDueDate = directPlacement.invoiceDueDate
      state.fee = directPlacement.fee
    }
  },
  actions: {
    save ({ state }) {
      return api.doPost({ path: PATH_DIRECT_PLACEMENTS, data: state })
    },
    update ({ state }) {
      return api.doPut({ path: PATH_DIRECT_PLACEMENTS, data: state })
    },
    getDirectPlacement: ({ commit, dispatch }, { id }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting permanent placement, please wait...' })

      return api.doGet({ path: `${PATH_DIRECT_PLACEMENTS}/${id}` })
        .then(json => json.data)
        .then(directPlacement => {
          commit('setDirectPlacement', directPlacement)
          commit('updateStatus', { status: COMPLETE })
          return directPlacement
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveDirectPlacement: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving permanent placement, please wait...' })

      const actionName = state.id ? 'update' : 'save'
      return dispatch(actionName).then(response => {
        if (!response.data) {
          throw new Error('Unable to save permanent placement. Check required fields.')
        }

        notifySuccess(dispatch, 'Permanent placement saved')
        commit('updateStatus', { status: COMPLETE })

        return response
      }).catch((error) => {
        commit('updateStatus', { status: ERROR, error })
        notifyError(dispatch, 'Unable to save permanent placement. Try again later')
        throw error
      })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    deleteDirectPlacement ({ commit, dispatch }, id = null) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Deleting permanent placement, please wait...' })
      return api.doDelete({ path: `${PATH_DIRECT_PLACEMENTS}/${id}` })
        .then(response => {
          if (!response.data) {
            throw new Error('Unable to delete permanent placement')
          } else {
            commit('updateStatus', { status: COMPLETE })
            notifySuccess(dispatch, 'Permanent placement deleted')
          }
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to delete permanent placement')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    clearDirectPlacement: ({ commit }) => {
      commit('clearDirectPlacement')
      return commit('updateStatus', { status: NOT_STARTED })
    }
  }
}

export default directPlacement
